<script>
import Feed from "./Feed.vue";
import Search from "./Search.vue";

export default Vue.extend({
  components: {
    Feed,
    Search,
  },
  data() {
    return {
      section: null,
      tags: [],
      readTags: [],
      searchTags: [],
    };
  },
  async mounted() {
    await axios.get("/api/news/tags").then(this.onTagsLoad);

    this.updateState({
      section: _.get(this.$route.query, "section", "feed"),
      tags: _.get(this.$route.query, "tags"),
    });
  },
  methods: {
    updateState(delta) {
      if (delta.section) {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, {
            section: delta.section,
          }),
        });

        this.section = delta.section;

        if (delta.tags == null || delta.tags.length == 0) {
          switch (delta.section) {
            case "announcements": {
              delta.tags = _.map(this.readTags, "hash");
              break;
            }
            default: {
              delta.tags = [];
              break;
            }
          }
        }
      }

      if (delta.tags) {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, {
            tags: delta.tags,
          }),
        });

        this.tags = delta.tags;
      }

      this.proxyToAll("updateState", delta);
    },
    async onTagsLoad({ data }) {
      this.readTags = data.read;
      this.searchTags = data.search;
    },
    onSectionChange(section) {
      this.updateState({ section });
    },
    onTagsChange(tags) {
      this.updateState({ tags });
    },
    filterChildren(name) {
      return _.filter(
        this.$children,
        (component) => _.get(component.$options, "_componentTag") == name
      );
    },
    proxyTo(componentName, handler, ...args) {
      const components = this.filterChildren(componentName);

      for (const component of components) {
        const func = component[handler];

        if (func) {
          func.apply(component, args);
        }
      }
    },
    proxyToAll(handler, ...args) {
      this.proxyTo("feed", handler, ...args);
      this.proxyTo("search", handler, ...args);
    },
  },
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/news/Container.vue